import * as React from "react";
import type { SVGProps } from "react";
const SvgFlag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 4c-.55 0-1-.45-1-1s.45-1 1-1h2a1.003 1.003 0 0 1 .984 1.176c2.374-.465 4.696.22 6.813.843l.003.001.025.007c2.69.788 5.223 1.528 7.685.093.39-.23.87-.17 1.2.14s.4.79.19 1.19c0 0-.83 1.67-.83 5.11 0 2.556.838 4.931.888 5.073l.002.007c.17.45-.02.96-.43 1.21-1.37.81-2.75 1.09-4.1 1.09l-.02.02c-1.794 0-3.53-.511-5.148-.988l-.042-.012-.025-.007c-2.513-.736-4.887-1.43-7.195-.35V21c0 .55-.45 1-1 1s-1-.45-1-1zm2 10.444c2.687-.9 5.334-.13 7.724.567l.066.019c2.44.72 4.76 1.4 7.01.45-.3-1.04-.74-2.9-.74-4.91 0-1.61.17-2.9.37-3.86-2.506.63-4.963-.098-7.19-.757l-.01-.003-.025-.007C9.689 5.206 7.31 4.51 5 5.598z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFlag;
